// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';
import WarrantyExpirationDateRangeCriteria from './warranty-expiration-date-range-criteria';
import WarrantyExpirationDealerCriteria from './warranty-expiration-dealer-criteria';
import WarrantyExpirationTypesCriteria from './warranty-expiration-types-criteria';

const WarrantyExpirationReportCriteria = props =>
    <div className='warranty-expiration-report-criteria report-criteria'>
        <div className='criteria-container'>
            <WarrantyExpirationDealerCriteria
                allowedAccounts={props.allowedAccounts}
                onDealerSelectClick={props.onDealerSelectClick}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedDealers={props.criteria.selectedDealers}
            />
            <WarrantyExpirationTypesCriteria
                onSelectAllTypes={props.onSelectAllTypes}
                onTypeSelectClick={props.onTypeSelectClick}
                warrantyTypes={props.criteria.warrantyTypes}
            />
            <WarrantyExpirationDateRangeCriteria
                expirationDate={props.criteria.expirationDate}
                onExpirationDateChange={props.onExpirationDateChange}

            />

        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onRunReport}
            showExport={true}
            showReport={true}
        />
    </div>;

WarrantyExpirationReportCriteria.displayName = 'WarrantyExpirationReportCriteria';
WarrantyExpirationReportCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    onDealerSelectClick: PropTypes.func.isRequired,
    onExpirationDateChange: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    onSelectAllTypes: PropTypes.func.isRequired,
    onTypeSelectClick: PropTypes.func.isRequired
};

export default WarrantyExpirationReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/components/warranty-expiration-report-criteria.js